<template>
  <div v-if="categories" :class="{ 'animate-pulse': fetching }">
    <template v-for="(item, index) in categories" :key="item.id">
      <SideNavigationItem
        v-if="!isHiddenForPLPNavigation(item)"
        :category="item"
        :index="index"
      />
    </template>
    <!-- The browser parks its link tooltip in the bottom-left corner, right on
         top of the last entry once the list is scrolled to its end, so the list
         keeps a run-out below it to scroll clear of (ECOM-2796). -->
    <div class="h-10" aria-hidden="true" />
  </div>
</template>

<script setup lang="ts">
import type { Category } from '@scayle/storefront-nuxt'

defineProps({
  categories: {
    type: Array as PropType<Category[]>,
    default: () => [],
  },
  fetching: {
    type: Boolean,
    required: false,
  },
})
</script>
